// RefundSlip.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from "date-fns";
import { useAppContext } from '../AppContext';

const printStyles = `
  @media print {
    @page {
      size: 80mm auto;
      margin: 0 !important;
      padding: 10px !important;
    }
    body {
      width: 80mm;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1.2;
    }
    .print-container {
        width: 100%;
        font-size: 12px !important; /* Base font size for print */
        min-height: unset; /* Remove any minimum height constraints */
        height: auto; /* Let height be determined by content */
        break-inside: avoid; /* Prevent page breaks within the container */
        margin: 0 !important; /* Remove margin */
        padding: 0 !important; /* Remove padding */
    }
    h3 { font-size: 20px !important; margin: 4px 0; }
    h4 { font-size: 14px !important; margin: 4px 0; }
    img { max-width: 60px; height: auto; }
    .MuiTypography-root { font-size: 12px; }
    .MuiTableCell-root { font-size: 12px;padding: 2px 8px !important; }
    .MuiGrid-item { font-size: 12px;padding: 2px !important; }
  }
  
    `;

const RefundSlipPrint = React.forwardRef(({ refundDetails }, ref) => {
  const { t } = useAppContext();
  return (
    <Box ref={ref} className="print-container">
      <style>{printStyles}</style>
      <Typography variant="h4" gutterBottom>
        {t("Refund Slip")}
      </Typography>
      <Typography variant="body1">
        <strong>{t("Date")}:</strong> {refundDetails?.timestamp 
          ? format(new Date(refundDetails.timestamp.toLocaleString()), "dd-MM-yyyy hh:mm a") 
          : t("N/A")}
      </Typography>
      <Typography variant="body1">
        <strong>{t("Order ID")}:</strong> {refundDetails?.orderId || t("N/A")}
      </Typography>
      <Typography variant="body1">
        <strong>{t("Order Date")}:</strong> {refundDetails?.orderDate
          ? format(new Date(refundDetails.orderDate.toDate()), "dd-MM-yyyy hh:mm a")
          : t("N/A")}
      </Typography>
      <Typography variant="body1">
        <strong>{t("Amount")}:</strong> {refundDetails?.amount 
          ? refundDetails.amount.toLocaleString('my-MM') 
          : '0'} MMK
      </Typography>
      <Typography variant="body1">
        <strong>{t("Reason")}:</strong> {refundDetails?.reason || t("N/A")}
      </Typography>
    </Box>
  );
});

export default RefundSlipPrint;
